<ng-container *ngIf='!showTable; else tableTemplate'>
  <div class="row">
    <div class="col col-12">
      <app-select [items]="tags" (selection)="onTagChange($event)" [label]="'Filter by tags'" [multi]="true"></app-select>
    </div>
  </div>
  <div class="row">
    <div class="col col-12 text-center my-4">
      <span class="font-size-16 font-weight-bold ">Selected {{ selectedContacts?.length || 0 }} contacts</span>
    </div>
  </div>
</ng-container>
<ng-template #tableTemplate>
<app-table
  #tableComponent
  (rowSelected)='onRowSelected($event)'
  *ngIf='tableReady'
  [columns]='tableColumns'
  [dataSourceParams]='tableDataSourceParams'
  [dataSource]='dataSource'
  [filters]='tableFilters'
  [forceSelectPage]='preselectAllContacts'
  [preselectedIdentifier]="'contact_id'"
  [preselected]='preselectedContactIds'
  [selectable]='true'
  [showPagination]='false'></app-table>
</ng-template>